import { request } from '@ygtechnologies/bygr-frontend-component-library';
import { ReportEmbedConfig, ReportTheme } from '@ygtechnologies/embedded-reports';
import { getCoreApiUrl } from '@/utils/ajax';


export function generateReportToken(profileId: number, report: string): Promise<ReportEmbedConfig> {
    return request(getCoreApiUrl() + `/v1/analysis/${report}/embed`, {
        method: 'POST',
        json: true,
        query: { profileId },
    }).then((x) => x.json());
}

export function getAnalyticsTheme(profileId: number) {
    return request(getCoreApiUrl() + `/v1/analysis/theme`, {
        method: 'GET',
        json: true,
        query: { profileId },
    }).then((x) => x.json());
}

export function setAnalyticsTheme(profileId: number, theme: ReportTheme) {
    return request(getCoreApiUrl() + `/v1/analysis/theme`, {
        method: 'PUT',
        json: true,
        body: theme,
        query: { profileId },
    }).then((x) => x.json());
}
